import React from "react";
import { Settings, Save } from "lucide-react";

export default function GeneralSettings() {
  return (
    <div className="general-settings">
      <div className="general-settings__grid">
        {/* General Settings Card */}
        <div className="settings-card">
          <div className="settings-card__header">
            <Settings size={20} />
            <h3 className="settings-card__title">General Settings</h3>
          </div>

          <div className="settings-card__content">
            <div className="form-field">
              <label htmlFor="orgName" className="form-field__label">
                Organization Name
              </label>
              <input
                id="orgName"
                type="text"
                defaultValue="Acme Security Corp"
                className="form-field__input"
              />
            </div>

            <div className="form-field">
              <label htmlFor="orgDescription" className="form-field__label">
                Organization Description
              </label>
              <textarea
                id="orgDescription"
                rows={4}
                defaultValue="A leading security solutions provider focused on enterprise-grade threat detection and incident response."
                className="form-field__textarea"
              />
            </div>

            <div className="form-field">
              <label htmlFor="timezone" className="form-field__label">
                Timezone
              </label>
              <input
                id="timezone"
                type="text"
                defaultValue="UTC-5 (Eastern Time)"
                className="form-field__input"
              />
            </div>
          </div>

          <div className="settings-card__footer">
            <button className="btn btn--primary">
              <Save size={16} />
              Save Changes
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
